import { getLang, initI18n } from "./i18n";
import { pickText, PRODUCT_META } from "./site-data";
import { productMark, productThumb } from "./product-visual";

function escapeHtml(s: string): string {
  return s.replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ] as string,
  );
}

function render(): void {
  const lang = getLang();
  const isZh = lang === "zh";
  const root = document.getElementById("quickstart-grid");
  if (!root) return;
  root.innerHTML = "";

  for (const p of PRODUCT_META) {
    const card = document.createElement("article");
    card.className = "instrument-card";
    card.dataset.slug = p.slug;
    card.innerHTML = `
      <img
        class="instrument-thumb"
        src="${productThumb(p.key)}"
        alt="${escapeHtml(pickText(p.title, lang))}${isZh ? " 演奏预览" : " performance preview"}"
        width="480"
        height="270"
        loading="lazy"
        decoding="async"
      />
      <div class="instrument-card-body">
        <div class="instrument-card-head">
          ${productMark(p.key)}
          <strong>${escapeHtml(pickText(p.title, lang))}</strong>
          <span class="chip free">${isZh ? "免费可用" : "Free to use"}</span>
        </div>
        <p>${escapeHtml(pickText(p.quickstartSummary, lang))}</p>
        <div class="feature-actions">
          <a class="btn secondary" href="/quickstart/${p.slug}.html">${isZh ? "进入 Quick Start" : "Open Quick Start"}</a>
          <a class="btn link" href="/manuals/blender/${p.slug}.html">${isZh ? "Blender 插件界面说明" : "Blender plugin guide"}</a>
          <a class="btn link" href="/advanced/${p.slug}.html">${isZh ? "自定义人物教程" : "Custom performer tutorial"}</a>
        </div>
      </div>
    `;
    root.appendChild(card);
  }
}

function renderStaticText(): void {
  const isZh = getLang() === "zh";
  const title = document.getElementById("quick-title");
  const sub = document.getElementById("quick-sub");
  const s1h = document.getElementById("quick-step-h1");
  const s2h = document.getElementById("quick-step-h2");
  const s3h = document.getElementById("quick-step-h3");
  const s4h = document.getElementById("quick-step-h4");
  const s1 = document.getElementById("quick-step-1");
  const s2 = document.getElementById("quick-step-2");
  const s3 = document.getElementById("quick-step-3");
  const s4 = document.getElementById("quick-step-4");
  const list = document.getElementById("quick-list-title");
  const footer = document.getElementById("quick-footer");

  if (title)
    title.textContent = isZh
      ? "四步完成演奏动画生成"
      : "Generate performance animation in four steps";
  if (sub)
    sub.textContent = isZh
      ? "七款软件都能免费下载使用。打开对应乐器的动作生成器，依次完成「角色设置 → MIDI 处理 → 执行操作」，生成动画数据，最后通过免费插件加载到 Blender 或 Unreal 中播放与渲染。"
      : "All seven are free to download and use. Open the motion generator for the target instrument, work through 角色设置 → MIDI 处理 → 执行操作, then load the generated data with the free Blender / Unreal plugins to preview or render.";
  if (s1h) s1h.textContent = isZh ? "角色设置" : "Performer setup";
  if (s2h) s2h.textContent = isZh ? "MIDI 处理" : "MIDI processing";
  if (s3h) s3h.textContent = isZh ? "执行操作" : "Execution";
  if (s4h) s4h.textContent = isZh ? "导入插件播放" : "Load in the plugins";
  if (s1)
    s1.textContent = isZh
      ? "在 Rust 端第一个标签页里选择演奏者，核对键域与默认手位。"
      : "Pick the performer in the Rust app's first tab and verify its key range and default hand positions.";
  if (s2)
    s2.textContent = isZh
      ? "选择 MIDI 文件并扫描轨道，勾选要生成动画的音轨后添加，再确认通道 / 帧率 / 量化。"
      : "Load the MIDI file, scan its tracks, tick the tracks to animate, then check channel / FPS / quantization.";
  if (s3)
    s3.textContent = isZh
      ? "点击生成指法与动画，在控制台确认结果，拿到供插件加载的结果文件。"
      : "Generate fingering and animation, confirm the result in the console, and collect the result file for the plugins.";
  if (s4)
    s4.textContent = isZh
      ? "用免费的 Blender / Unreal 插件加载结果文件并写回时间线，即可预览或渲染。"
      : "Load the result file with the free Blender / Unreal plugins and write it onto the timeline to preview or render.";
  const ppt = document.getElementById("quick-per-product-title");
  const pps = document.getElementById("quick-per-product-sub");
  if (ppt)
    ppt.textContent = isZh
      ? "每个产品都有独立的图文步骤"
      : "Every product has its own illustrated walkthrough";
  if (pps)
    pps.textContent = isZh
      ? "下面每个乐器都有一篇完整的 Quick Start：逐段讲解该产品 Rust 端界面上的标签页、按钮、参数含义与推荐点击顺序，页尾附 B 站演示视频，页内右侧带大纲导航。"
      : "Each instrument below has a full Quick Start: a section-by-section walkthrough of that product's Rust UI tabs, buttons, parameters and recommended click order, with a YouTube demo at the end and an on-page outline sidebar.";
  if (list) list.textContent = isZh ? "按乐器查看" : "Browse by instrument";  if (footer)
    footer.textContent = isZh
      ? "让演奏动画更快进入可交付状态。"
      : "Move performance animation into a usable production pipeline faster.";
}

function main(): void {
  initI18n();
  renderStaticText();
  render();
  document.addEventListener("langchange", () => {
    renderStaticText();
    render();
  });
}

main();
